import React from "react";
import { Table } from "antd";

// Sample data
const dataSource = [
  {
    key: "1",
    clientName: "singapore-01",
    clientId: "85974120-3541-4396-a750-816b33559d8c",
    region: "Singapore",
    clientManager: "chithramurugan@frontbridges.com",
    siteManagerEmail: "jetson.yousaf@frontbridges.com",
    siteManagerName: "Eye_Hospital01",
  },
  {
    key: "2",
    clientName: "singapore-02",
    clientId: "85974120-3541-4396-a750-816b33559d8c",
    region: "Singapore",
    clientManager: "chithramurugan@frontbridges.com",
    siteManagerEmail: "jeston02@frontbridges.com",
    siteManagerName: "Eye_Hospital02",
  },
  {
    key: "902",
    clientName: "singapore-09",
    clientId: "85974120-3541-4396-a750-816b33559d8c",
    region: "london",
    clientManager: "chithramurugan@frontbridges.com",
    siteManagerEmail: "jeston02@frontbridges.com",
    siteManagerName: "Eye_Hospital00",
  },
];

// Define the columns
const columns = [
  {
    title: "Client",
    dataIndex: "clientName",
    key: "clientName",
  },
  {
    title: "Region",
    dataIndex: "region",
    key: "region",
    render: (text, record, index) => {
      const previousRow = dataSource[index - 1];
      if (previousRow && previousRow.region === text) {
        return {
          children: text,
          props: {
            rowSpan: 0, // Hide this row
          },
        };
      } else {
        const nextRows = dataSource.slice(index + 1);
        const rowSpan = nextRows.reduce(
          (span, nextRow) => (nextRow.region === text ? span + 1 : span),
          1
        );
        return {
          children: text,
          props: {
            rowSpan,
          },
        };
      }
    },
  },
  {
    title: "Site Manager",
    render: (text, record) => (
      <div>
        <div>{record.siteManagerName}</div>
        {/* <div>{record.siteManagerEmail}</div> */}
      </div>
    ),
    key: "siteManager",
  },
  {
    title: "QC1",
    className: "text-center",
    render: () => <>✅</>,
    key: "qc1",
  },
  {
    title: <div className="text-center">QC8</div>,
    className: "text-center",
    render: (text, record, index) => {
      // Set rowSpan for QC2 column
      return {
        children: <>❌</>,
        props: {
          rowSpan: index === 0 ? dataSource.length : 0, // Set rowSpan only for the first row
        },
      };
    },
    key: "qc2",
  },
  {
    className: "text-center",
    title: <div className="text-center">QC2</div>,
    render: (text, record, index) => {
      // Set rowSpan for QC2 column
      return {
        children: <>✅</>,
        props: {
          rowSpan: index === 0 ? dataSource.length : 0, // Set rowSpan only for the first row
        },
      };
    },
    key: "qc2",
  },
  {
    title: "QC3",
    colSpan: 2,
    render: () => <>✅</>,
    key: "qc3",
  },
  {
    title: null,
    render: () => "20%", // No content for this cell
    key: "qc4",
  },
];

function TableTest() {
  return (
    <>
      {/* <Table
        scroll={{ x: 950 }}
        dataSource={dataSource}
        columns={columns}
        bordered
      /> */}
    </>
  );
}

export default TableTest;
